export { TestimonialCarousel } from './TestimonialCarousel';
